import { ApplicationConfig, APP_INITIALIZER, provideZonelessChangeDetection } from '@angular/core';
import { ResourcesConfig } from 'aws-amplify';
import { provideRouter, withHashLocation } from '@angular/router';
import { routes } from './app.routes';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withFetch,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { AuthInterceptor } from './shared/services/auth/auth.interceptor';
import { AmplifyConfigurationService } from './shared/services/auth/amplify-config.service';
import baseAuthConfig from '../aws-config';
import { environment } from '../environments/environment';
import { CurrencyPipe } from '@angular/common';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(routes, withHashLocation()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAmplify,
      deps: [AmplifyConfigurationService],
      multi: true,
    },
    CurrencyPipe,
  ],
};

export function initializeAmplify(amplifyService: AmplifyConfigurationService) {
  return () => {
    const finalConfig: ResourcesConfig = {
      ...baseAuthConfig,
      Auth: {
        ...baseAuthConfig.Auth,
        Cognito: {
          userPoolId: environment.userPoolId,
          userPoolClientId: environment.userPoolClientId,
          signUpVerificationMethod: 'code',
          loginWith: {
            email: true,
            oauth: {
              domain: environment.cognitoDomain,
              scopes: ['email', 'profile', 'openid'],
              redirectSignIn: [window.location.origin + '/'],
              redirectSignOut: [window.location.origin + '/'],
              responseType: 'code',
            },
          },
        },
      },
    };
    amplifyService.configure(finalConfig);
    return Promise.resolve();
  };
}
